/* ============================================================
   Size Chart modal — apertura/cierre (clon Klassy)
   - trigger: .chart_size  (PDP y QuickView)
   - panel:   .page_contents  (toggle .active)
   - overlay: .modal-popup__overlay (hermano del panel)
   - cierre:  botón .cancle-size, clic en overlay, tecla ESC

   DELEGACIÓN: los listeners van en `document`, no en cada trigger. Así funciona
   también con el QuickView, cuyo HTML (trigger + modal) se inyecta vía innerHTML
   DESPUÉS del DOMContentLoaded (un bind directo nunca lo vería). El modal correcto
   se resuelve por contexto: si el trigger está dentro del QuickView, se abre el
   .page_contents de ESE QuickView; si no, el global de la PDP.
   ============================================================ */
(function () {
  if (window.__sizeChartDelegated) return;
  window.__sizeChartDelegated = true;

  function panelForTrigger(trigger) {
    var scope = trigger.closest('.klassy-quickview-content') || trigger.closest('product-info');
    var panel = scope && scope.querySelector('.page_contents');
    return panel || document.querySelector('.page_contents');
  }

  function open(panel) {
    if (!panel) return;
    // PORTAL: dentro del QuickView, el drawer tiene transform (translateX), lo que
    // hace que el position:fixed del panel se ancle al drawer en vez del viewport
    // (sale dentro del QV en vez de centrado en pantalla). Lo movemos al <body>
    // para que se centre en toda la pantalla, igual que en la PDP. Se devuelve a su
    // sitio al cerrar (para que panelForTrigger lo reencuentre la próxima vez).
    if (panel.parentNode !== document.body && panel.closest('.klassy-quickview-content')) {
      var origin = panel.parentNode;
      var overlay = origin.querySelector('.modal-popup__overlay');
      panel._scOrigin = origin;
      panel._scOverlay = overlay || null;
      document.body.appendChild(panel);
      panel.classList.add('sc-portaled');
      if (overlay) {
        document.body.appendChild(overlay); // adyacente al panel: mantiene el selector "+ overlay"
        overlay.classList.add('sc-portaled');
      }
      // Tras reinsertar en el <body>, forzar reflow para que el navegador registre
      // el estado cerrado (top:100%) ANTES de aplicar .active. DOBLE rAF: en WebKit
      // (iOS) un solo rAF puede pintar el frame cerrado y el .active en el MISMO paint,
      // saltándose el primer frame de la transición de 0.45s (síntoma: "salta sin
      // animación"). Con dos rAF garantizamos que el estado cerrado se pinta en un
      // frame y .active en el siguiente, así la subida siempre se anima.
      void panel.offsetHeight;
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          panel.classList.add('active');
          document.body.classList.add('overflow-hidden');
        });
      });
      return;
    }
    panel.classList.add('active');
    document.body.classList.add('overflow-hidden');
  }

  function closeAll() {
    var any = false;
    document.querySelectorAll('.page_contents.active').forEach(function (p) {
      p.classList.remove('active');
      any = true;
      if (p._scOrigin) {
        // Devolver el panel portado a su sitio (QuickView) SOLO tras la animación de
        // bajada (~0.45s), para que el cierre se anime igual que en la PDP.
        var origin = p._scOrigin;
        var overlay = p._scOverlay;
        var node = p;
        setTimeout(function () {
          if (node.classList.contains('active')) return; // se reabrió mientras tanto
          node.classList.remove('sc-portaled');
          origin.appendChild(node);
          if (overlay) {
            overlay.classList.remove('sc-portaled');
            origin.appendChild(overlay);
          }
        }, 480);
        p._scOrigin = null;
        p._scOverlay = null;
      }
    });
    if (any) document.body.classList.remove('overflow-hidden');
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var trigger = e.target.closest('.chart_size');
    if (trigger) {
      e.preventDefault();
      open(panelForTrigger(trigger));
      return;
    }
    if (e.target.closest('.cancle-size') || e.target.closest('.modal-popup__overlay')) {
      closeAll();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' || e.key === 'Esc') closeAll();
  });
})();
